<style scoped>
img {
  width:60%

}

</style>

<template>
  <v-stepper v-model="step" style="height:100%;overflow-y:scroll;;" class="text-xs-left elevation-0">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > step" step="1">REST API specs</v-stepper-step>

      <v-divider></v-divider>

    </v-stepper-header>

    <v-stepper-items>


      <v-stepper-content step="1">
        <v-card>
          <open-api v-if="jsonApi" :api="jsonApi" md-theme="\'default\'"></open-api>
        </v-card>
        <v-btn
          color="primary"
          @click="step = 2"
        >
          Continue
        </v-btn>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
import OpenApi from 'vue-openapi'
import jsonApi from '@/assets/openapi.json'

export default {
  components: {
    OpenApi
  },

  data(){
    return {
      jsonApi: jsonApi
    }
  }
}
</script>